import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';

import { getAdminUserList, isUserSearching } from '../../../../actions/adminActions';

import CustomCheckbox from '../../shared/CustomCheckbox';
import CustomDateRangePicker from '../../shared/CustomDateRangePicker';

const allStatus = [
  { value: 'active', label: 'Active', statusId: 1 },
  { value: 'inactive', label: 'Inactive', statusId: 2 },
  { value: 'deleted', label: 'Deleted', statusId: 3 },
  { value: 'invited', label: 'Invited', statusId: 4 },
];
class UserSearch extends Component {
  static propTypes = {
    getAdminUserList: PropTypes.func,
    isUserSearching: PropTypes.func,
    isClearUser: PropTypes.bool,
    isSearched: PropTypes.bool,
    userSearchQuery: PropTypes.instanceOf(Object),
  }

  static defaultProps = {
    userSearchQuery: {},
    isClearUser: false,
    isSearched: false,
  };

  state = {
    accountOptions: [],
    statusOptions: allStatus,
    dateFormat: 'dd-MMM-yyyy',
    serverDateFormat: 'DD-MMM-YY',
    clearDates: true,
    searchTerm: {
      query: '',
      accountIds: [],
      statusIds: [],
      loginFrom: '',
      loginTo: '',
      updatedFrom: '',
      updatedTo: '',
      createdFrom: '',
      createdTo: '',
      pageNo: '1',
    },
  }

  UNSAFE_componentWillMount() {
    const { userSearchQuery } = this.props;
    this.updateSearchQuery(userSearchQuery);
  }

  UNSAFE_componentWillReceiveProps({ userSearchQuery, isClearUser, isSearched }) {
    if (isSearched && !isClearUser) {
      this.updateSearchQuery(userSearchQuery);
    }

    if (!isSearched && isClearUser) {
      this.setState({
        searchTerm: {
          query: '',
          accountIds: [],
          statusIds: [],
          loginFrom: '',
          loginTo: '',
          updatedFrom: '',
          updatedTo: '',
          createdFrom: '',
          createdTo: '',
          pageNo: '1',
        },
        clearDates: true,
      });
    }
  }

  updateSearchQuery = userSearchQuery => {
    const { searchTerm } = this.state;
    if (!_.isEmpty(userSearchQuery)) {
      const queryObj = _.cloneDeep(userSearchQuery);
      if (!_.isEmpty(queryObj.accountIds)) {
        queryObj.accountIds = queryObj.accountIds;
      }

      if (!_.isEmpty(queryObj.statusIds)) {
        queryObj.statusIds = queryObj.statusIds;
      }
      const updatedSearchTerm = { ...searchTerm, ...queryObj };
      this.setState({ searchTerm: updatedSearchTerm });
    }
  }

  handleStatusChange = e => {
    const { searchTerm, statusOptions } = this.state;
    const statusName = e.target.name;
    const isChecked = e.target.checked;
    let statusIds = searchTerm.statusIds;
    _.map(statusOptions, item => {
      if (item.value === statusName) {
        if (isChecked) {
          statusIds.push(item.statusId);
        } else {
          statusIds = _.filter(statusIds, i => i !== item.statusId);
        }
      }
    });
    this.setState({
      searchTerm: {
        ...searchTerm,
        statusIds,
      },
    }, () => {
      this.handleSearchUser();
    });
  }

  handleLoginDateChange = ({ startDate, endDate }) => {
    const { searchTerm, serverDateFormat } = this.state;
    this.setState({
      searchTerm: {
        ...searchTerm,
        loginFrom: startDate ? moment(startDate).format(serverDateFormat).toUpperCase() : '',
        loginTo: endDate ? moment(endDate).format(serverDateFormat).toUpperCase() : '',
      },
      clearDates: false,
    }, () => {
      if(this.state.searchTerm.loginFrom && this.state.searchTerm.loginTo){
      this.handleSearchUser();
      }
    });
  }

  handleCreatedDateChange = ({ startDate, endDate }) => {
    const { searchTerm, serverDateFormat } = this.state;
    this.setState({
      searchTerm: {
        ...searchTerm,
        createdFrom: startDate ? moment(startDate).format(serverDateFormat).toUpperCase() : '',
        createdTo: endDate ? moment(endDate).format(serverDateFormat).toUpperCase() : '',
      },
      clearDates: false,
    }, () => {
      if(this.state.searchTerm.createdFrom && this.state.searchTerm.createdTo){
      this.handleSearchUser();
      }
    });
  }

  handleUpdatedDateChange = ({ startDate, endDate }) => {
    const { searchTerm, serverDateFormat } = this.state;
    this.setState({
      searchTerm: {
        ...searchTerm,
        updatedFrom: startDate ? moment(startDate).format(serverDateFormat).toUpperCase() : '',
        updatedTo: endDate ? moment(endDate).format(serverDateFormat).toUpperCase() : '',
      },
      clearDates: false,
    }, () => {
      if(this.state.searchTerm.updatedFrom.length > 0 && this.state.searchTerm.updatedTo.length >0 ){
      this.handleSearchUser();
      }
    });
  }


  handleSearchUser = e => {
    if (e) {
      e.preventDefault();
    }
    const { searchTerm } = this.state;
    this.props.getAdminUserList(searchTerm);
    this.props.isUserSearching();
  }

  renderStatusOptions = () => {
    const { statusOptions, searchTerm } = this.state;
    const { statusIds } = searchTerm;
    return _.map(statusOptions, status => {
      const isChecked = !_.isEmpty(statusIds) && statusIds.includes(status.statusId);
      return (
        <div key={status.statusId} className="user-search--checkbox-container">
          <CustomCheckbox
            name={status.value}
            onChange={this.handleStatusChange}
            label={status.label}
            checked={isChecked}
          />
        </div>
      );
    });
  }

  render() {
    const { dateFormat, clearDates } = this.state;
    return (
      <div className="user-search user-search--vertical">
        <div className="user-search--box">
          <div className="user-search--form">
            <div className="user-search--form-group zindex-1">
              <label htmlFor="status">Status</label>
              <div className="user-search--checkbox-group">
                {this.renderStatusOptions()}
              </div>
            </div>
            <div className="user-search--form-group user-search--form-dropdown">
              <label htmlFor="lastLogin">Last Login</label>
              <CustomDateRangePicker
                handleDateChange={this.handleLoginDateChange}
                dateFormat={dateFormat}
                placeholderFrom="From"
                placeholderTo="To"
                clearable
                clearDates={clearDates}
                id="loginDate"
              />
            </div>
            <div className="user-search--form-group user-search--form-dropdown">
              <label htmlFor="createdDate">Created Date</label>
              <CustomDateRangePicker
                handleDateChange={this.handleCreatedDateChange}
                dateFormat={dateFormat}
                placeholderFrom="From"
                placeholderTo="To"
                clearable
                clearDates={clearDates}
                id="createdDate"
              />
            </div>
            <div className="user-search--form-group user-search--form-dropdown">
              <label htmlFor="updatedDate">Last Modified</label>
              <CustomDateRangePicker
                handleDateChange={this.handleUpdatedDateChange}
                dateFormat={dateFormat}
                placeholderFrom="From"
                placeholderTo="To"
                clearable
                clearDates={clearDates}
                id="lastModifiedDate"
              />
            </div>
            <div className="user-search--form--footer hide">
              <button onClick={this.handleSearchUser} type="button" className="button primary">Search</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({ admin }) => {
  return {
    userSearchQuery: admin.userSearchQuery,
    isClearUser: admin.isClearUser,
    isSearched: admin.isSearched,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminUserList: bindActionCreators(getAdminUserList, dispatch),
    isUserSearching: bindActionCreators(isUserSearching, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSearch);
